<template>
  <IntegrationsHelpDialog image item="integrationKanbanDialogAuto">
    <template #image>
      <VImg :src="require('@/assets/img/integration3.png')" />
    </template>
    <template #title>
      {{ $t('title') }}
    </template>
    <template #text>
      {{ $t('text') }}
    </template>
    <template #add-text>
      <i18n path="text2" for="settings">
        <router-link
          :to="{
            name: 'vacancy',
            vacancyId: $route.params.vacancyId,
          }"
        >
          {{ $t('settings') }}
        </router-link>
      </i18n>
    </template>
  </IntegrationsHelpDialog>
</template>

<script>
import IntegrationsHelpDialog from '@/components/Integrations/IntegrationsHelpDialog';

export default {
  name: 'IntegrationsHelpDialogKanbanAuto',
  components: { IntegrationsHelpDialog },
  setup() {

  },
};
</script>

<style scoped>

</style>

<i18n lang="yml" locale="ru">
  title: Настроено автоматическое приглашение кандидатов
  text: 'Вы настроили автоматическое приглашение кандидатов, поэтому кандидатам будет отправляться приглашение на интервью сразу после того, как они откликнутся на вакансию на job-сайте.'
  text2: 'Если вы хотите самостоятельно выбирать, кому отправлять приглашения, вы можете изменить это в {0}'
  settings: настройках
</i18n>
